import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { MobileSheet } from '@/shared/components/MobileSheet';
import { getClientePrimeiroNome } from '../../domain/usecases/clienteDisplay';

export function PedidoIniciadoPopup({
  titulo, thumbnail, clienteNome, onDismiss,
}: {
  titulo:        string;
  thumbnail:     string;
  clienteNome?:  string | null;
  onDismiss:     () => void;
}) {
  const primeiroNome = getClientePrimeiroNome(clienteNome);
  return (
    <MobileSheet aberto titulo="Sua música começou" onClose={onDismiss}>
      <div className="px-6 pb-6">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-orange-500 to-rose-500 flex items-center justify-center shadow-xl shadow-orange-500/40 animate-scale-in animate-vibe-hud-pulse">
            <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 3v10.55A4 4 0 1 0 14 17V7h4V3h-6z" />
            </svg>
          </div>
        </div>

        <p className="flex items-center justify-center gap-1.5 text-center text-orange-400/80 text-xs font-bold uppercase tracking-widest mb-2">
          <Sparkles size={12} className="shrink-0" aria-hidden />
          {primeiroNome ? `${primeiroNome}, é a sua vez!` : 'É a sua vez!'}
          <Sparkles size={12} className="shrink-0" aria-hidden />
        </p>
        <p className="text-center text-white text-lg font-bold leading-snug mb-4 line-clamp-3">{titulo}</p>

        <div className="relative rounded-xl overflow-hidden aspect-video mb-5 shadow-lg">
          <img src={thumbnail} alt={titulo} className="w-full h-full object-cover" />
          <div className="absolute inset-0 pointer-events-none overflow-hidden rounded-xl">
            <motion.div
              className="absolute left-0 -top-4 -bottom-4 w-1/3 bg-gradient-to-r from-transparent via-white/[0.12] to-transparent"
              initial={{ x: '-100%' }}
              animate={{ x: '200%' }}
              transition={{ duration: 0.8, ease: 'easeInOut' }}
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-3">
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 rounded-full bg-orange-500 flex items-center justify-center">
                <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
              <span className="text-white text-xs font-medium">Tocando agora na TV!</span>
            </div>
          </div>
        </div>

        <button
          onClick={onDismiss}
          className="w-full py-3.5 rounded-2xl bg-gradient-to-r from-orange-500 to-rose-500 text-white font-bold text-sm shadow-lg shadow-orange-500/30 active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60 transition-transform"
        >
          Ótimo!
        </button>
      </div>
    </MobileSheet>
  );
}
